import { render, staticRenderFns } from "./TransparentBlock.vue?vue&type=template&id=83bc24fe&"
import script from "./TransparentBlock.vue?vue&type=script&lang=js&"
export * from "./TransparentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports